import React from 'react'
import { Form, Input, Button, Row, Col, Spin } from 'antd'

const Information = ({ mainNext, savingFirstSurvey }) => {

    const onFinish = (data) => {
        mainNext(data, 'additionalComments')
    }

    return (
        <div>
            <h5 className="gx-blue-font gx-mb-3">Additional Comments / Nurse Comments:</h5>
            <Form
                name="nest-messages"
                onFinish={onFinish}
            >
                <Row className="gx-px-2">
                    <Col xl={24} md={24} sm={24} xs={24}>
                        <Form.Item name='additionalComment'>
                            <Input.TextArea rows={10} />
                        </Form.Item>
                    </Col>
                </Row>
                <div className="footer gx-d-flex gx-justify-content-end">
                    <div className="buttons">
                        <div className="steps-action">
                            {!savingFirstSurvey ?
                                <Button className="gx-pt-0 gx-mb-0" type="primary" htmlType="submit">
                                    Finish
                            </Button> :
                                <Spin size="small" color='blue'><Button className="gx-pt-0 gx-mb-0" type="primary" disabled>
                                    Finish
                            </Button></Spin>
                            }
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default Information
